import { NgModule } from '@angular/core';
import { PipeModule } from '../pipes/pipe-module';
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    PipeModule,
    TranslatePipe,
    TranslateDirective
  ],
  providers: [],
  exports: [CommonModule,PipeModule, TranslatePipe, TranslateDirective],
})
export class StandaloneSharedModule { }
